module.exports = __webpack_public_path__ + "img/expire@2x.7d54f1f4.png";